import React from 'react'
import { Helmet } from 'react-helmet-async'

export const NotFoundPage: React.FC = (props: any) => {
  // If rendered on the server, StaticRouter provides props.staticContext
  // We set status=404 there so entry-server can pick it up.
  const isReal404 = !!(props && props.staticContext)

  if (isReal404) {
    props.staticContext.status = 404
  }

  return (
    <section className="py-24 bg-background">
      {isReal404 && (
        <Helmet>
          <title>Страница не найдена — SAFONOVA</title>
          <meta name="robots" content="noindex,follow" />
        </Helmet>
      )}
      <div className="container mx-auto px-6 text-center">
        <h1 className="text-4xl font-semibold mb-4">404 — Страница не найдена</h1>
        <p className="text-foreground/70 mb-6">К сожалению, страница, которую вы искали, не существует.</p>
      </div>
    </section>
  )
}

export default NotFoundPage
